import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant16PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 1452 529",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M70.209 458.394C101.124 366.853 173.946 294.703 264.413 261.866C331.963 237.339 405.99 233.676 477.114 244.175C574.506 258.56 674.267 298.589 768.085 268.746C835.813 247.212 883.393 173.319 831.658 109.389C802.798 73.6481 750.036 61.3177 706.567 76.1946C663.098 91.0715 630.083 130.252 617.886 174.57C605.69 218.844 613.061 267.272 633.254 308.507C658.362 359.795 704.333 418.32 759.865 437.262C823.84 459.108 894.293 451.156 958.805 436.056C1117.4 398.93 1265.37 317.621 1381.75 203.609",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant16PathwayIllustration as default };
